module.exports = __webpack_public_path__ + "img/download_explain_2.ec996d45.png";